import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import GenQRView from '@/views/QRCode.vue'
import CheckFaceInfoView from '@/views/CheckFaceInfo.vue'

import StatementView from '@/views/Statement.vue' 
import DefaultLayout from '@/layouts/DefaultLayout' 

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  }, 
  {
    path: '/',
    name: 'eBanking',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: '/users/',
        name: 'Users Management',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Users.vue'),
      },
      {
        path: '/statement/',
        name: 'Statement Management',
        component: StatementView
      },
      {
        path: '/qrcode/',
        name: 'QR code',
        component: GenQRView
      },   
      {
        path: '/checkfaceinfo/',
        name: 'Check Face Info',
        component: CheckFaceInfoView
      }, 
    ],
  }, 
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
